import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography } from '@mui/material';
import { isBrowser, downloadApp, downloadAppHero } from 'common';
import { Language } from 'language';
import {
    useLocation,
} from 'react-router-dom';

const style = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflowY: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

const contentStyle = {
    width: '100%',
    maxWidth: 480,
    display: 'flex',
    flexDirection: 'column',
    p: 4
};

const DownloadApp = () => {
    const [open, setOpen] = useState(null);
    const isRunningInBrowser = isBrowser();
    const location = useLocation();
    const { pathname } = location;

    useEffect(() => {
        if (!pathname.includes('wallet')) {
            setOpen(true);
        }
    }, [pathname]);

    return (
        <>
            {open && isRunningInBrowser && (
                <Modal
                    open={open}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Box sx={contentStyle}>
                            <Typography
                                id="modal-modal-title"
                                variant="h3"
                                component="h1"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                color="primary"
                                fontWeight="bold"
                                paddingBottom={6}
                            >
                                Terra Charge
                            </Typography>
                            {/* hero illustration */}
                            <Box display="flex" alignItems="center" justifyContent="center" paddingBottom={6}>
                                {downloadAppHero('80%')}
                            </Box>
                            <Typography
                                variant="h4"
                                component="h2"
                                fontWeight="bold"
                                textAlign="center"
                                paddingBottom={3}
                            >
                                {Language.generic.download_app_tagline}
                            </Typography>
                            <Typography
                                variant="body1"
                                textAlign="center"
                                paddingBottom={6}
                            >
                                {Language.generic.download_app_description}
                            </Typography>
                            {downloadApp(50)}
                        </Box>
                    </Box>
                </Modal>
            )}
        </>
    )
}

export default DownloadApp